
export default {
  users: [],
  roles: [],
  user: {},
  chats:[],
  chatSearchQuery: ""
}
